/** Decides when to hold an active geolocation watch: only while live-follow is enabled,
 *  the document is visible, and the Now tab is active (foreground-only, battery-bounded).
 *  Pure of any browser API — the caller supplies watch()/clear() (navigator.geolocation). */
export class LiveFollowController {
  #watchId: number | null = null;
  constructor(private deps: { watch: () => number; clear: (id: number) => void }) {}

  update(s: { enabled: boolean; visible: boolean; onNow: boolean }): void {
    const shouldWatch = s.enabled && s.visible && s.onNow;
    if (shouldWatch && this.#watchId === null) {
      this.#watchId = this.deps.watch();
    } else if (!shouldWatch && this.#watchId !== null) {
      this.deps.clear(this.#watchId);
      this.#watchId = null;
    }
  }

  get active(): boolean { return this.#watchId !== null; }
  stop(): void { this.update({ enabled: false, visible: false, onNow: false }); }
}
